import { ApplicationState } from '../types';

export const getUncollectedSharesLookup = ({
  sellUncollectedShares,
}: ApplicationState) => sellUncollectedShares?.uncollectedShares;
